import { Button, MenuItem, Stack } from "@mui/material";
import useReservationQuestionStore from "../../../stores/useReservationQuestionStore";
import update from "../../../api/auth/itemCategories/reservationQuestions/update";
import create from "../../../api/auth/itemCategories/reservationQuestions/create";
import { useForm } from "react-hook-form";
import useAlertStore from "../../../stores/useAlertStore";
import WushTextField from "../WushTextField";

export default function ReservationQuestionForm({ reservationQuestion, itemCategory, afterCreate, afterUpdate }) {
  const { addReservationQuestion, updateReservationQuestion } = useReservationQuestionStore();

  const { setAlertMessage } = useAlertStore();

  const { register, handleSubmit, formState: { isDirty } } = useForm();

  const onSubmit = (data) => {
    if(reservationQuestion?.id) {
      update(itemCategory.id, reservationQuestion.id, data, (response) => {
        updateReservationQuestion(response);
        setAlertMessage("Question updated successfully", "success");
        afterUpdate && afterUpdate(response);
      }, (error) => {
        console.log(error);
      });
    } else {
      create(itemCategory.id, data, (response) => {
        addReservationQuestion(response);
        afterCreate && afterCreate(response);
      }, (error) => {
        console.log(error);
      });
    }
  };

  return (
    <Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack mb={2}>
          <WushTextField formRegistration={register("question")} label="Question" defaultValue={reservationQuestion?.question} />
        </Stack>
        <Stack mb={2}>
          <WushTextField formRegistration={register("answer_data_type")} label="Type" defaultValue={reservationQuestion?.answer_data_type} select>
            <MenuItem value="text">Text</MenuItem>
            <MenuItem value="number">Number</MenuItem>
            <MenuItem value="date">Date</MenuItem>
            <MenuItem value="boolean">Yes/No</MenuItem>
          </WushTextField>
        </Stack>
        <Stack mb={2}>
          <WushTextField formRegistration={register("required")} label="Required" defaultValue={reservationQuestion?.required} select>
            <MenuItem value={true}>Yes</MenuItem>
            <MenuItem value={false}>No</MenuItem>
          </WushTextField>
        </Stack>
        <Stack>
          <Button disabled={!isDirty} variant="outlined" type="submit">{reservationQuestion?.id ? "Update" : "Create"}</Button>
        </Stack>
      </form>
    </Stack>
  );
}